module.exports = __webpack_public_path__ + "img/lnk-sales-force-footer.c42edf69.svg";